const GAME_ENTER_MODE_COOKIE = 'game_enter_mode';
const GAME_ENTER_MODE_MAX_AGE = 30;

export const setGameEnterMode = (mode: 'play' | 'demo') => {
  document.cookie = `${GAME_ENTER_MODE_COOKIE}=${mode}; Max-Age=${GAME_ENTER_MODE_MAX_AGE}; Path=/; SameSite=Lax`;
};
